import { createApi } from '@reduxjs/toolkit/query/react';
import { createAppBaseQuery } from '../../services/baseQuery';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  baseQuery: createAppBaseQuery(),
  endpoints: (builder) => ({
    search: builder.query({
      query: (params) => ({ url: '/search', params }),
    }),
    getFacets: builder.query({
      query: (params) => ({ url: '/search/facets', params }),
    }),
    getSuggestions: builder.query({
      query: (q) => `/search/suggestions?q=${encodeURIComponent(q)}`,
    }),
  }),
});

export const { useSearchQuery, useGetFacetsQuery, useGetSuggestionsQuery } = searchApi;
